import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import afterBoxImg from '../../../asset/img/result_after_box_img.png';
import speaker from '../../../asset/img/common/speaker_icon.svg';
import resultquery_adddocument_img from '../../../asset/img/resultquery_adddocument_img.svg';
import resultquery_installment_img from '../../../asset/img/resultquery_installment_img.svg';

import FullButton, { ResultButton } from '../../../components/common/FullButton';
import Typography from '../../../components/common/Typography';
import { formatNumber, getAlertMessageFunction, magamCertifyCheck } from '../../../common/Util';
import Button from '../../../components/common/Button';
import SlideDialogV from '../../../components/common/SlideDialogV';
import { getInstallment, resetMobileYA, setInstallmentApi } from '../resultQuerySlice';
import { getCertifyFlag, getYAStart } from '../../common/commonSlice';
import IframeViewer from '../../../components/common/IframeViewer';
import CollapsibleBanner from '../../../components/CollapsibleBanner';
import { getResultQueryDescription, getResultQueryTitle } from '../util';
import TabContentPanel from '../../../components/TabContentPanel';
import { resultQueryTabs } from '../../../common/data';
import Tab1Content from './Tab1Content';
import ResultReport from './ResultReport';
import InstallmentModal from './InstallmentModal';
import AlertContext from '../../../context/AlertContext';

const AfterAuthentication = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation('resultQuery');
  const { t: tCommon } = useTranslation('common');
  const { resultData, comYASetting } = useSelector(state => state.resultQuery);
  const { isMagam, isCertify, msgData } = useSelector(state => state.common);

  const {
    alertActions: { alertMessage },
  } = useContext(AlertContext);

  const [isReset, setIsReset] = useState(false); //초기화~?
  const [installment, setInstallment] = useState(null); //분납신청 개월수
  const [isInstallment, setIsInstallment] = useState(false); //분납신청 모달 열기
  const [isAddDocument, setIsAddDocument] = useState(false); //추가 서류 전액조건 모달열기
  const [iframeSrc, setIframeSrc] = useState('');
  const [activeTab, setActiveTab] = useState('1');
  const TabList = resultQueryTabs(t, resultData, comYASetting);

  useEffect(() => {
    //마감 되었으면 월급날 검토 탭으로 이동
    if (isMagam) setActiveTab('2');
  }, [isMagam]);

  const handleReset = async () => {
    try {
      //초기화는 마감만 체크
      if (!magamCertifyCheck(isMagam, false)) {
        return;
      }
      // 모바일 YA 리셋
      const { resultCode: resetCode, msg } = await dispatch(resetMobileYA()).unwrap();

      console.log('resetCode>>', resetCode);
      if (Number(resetCode) !== 1) {
        alertMessage(msg);
        return;
      }

      // YA 시작 처리
      const { resultCode: yaCode } = await dispatch(getYAStart()).unwrap();

      if (yaCode !== '1') {
        return;
      }

      // 성공 처리
      alertMessage(msg);
      setIsReset(false);
      dispatch(getCertifyFlag()); //인증초기화
      navigate('/');
    } catch (error) {
      console.error('Reset process failed:', error);
      alertMessage(t('common:error.systemError'));
    }
  };

  const handleTabChange = value => {
    setActiveTab(value);
  };

  //초기화 하시겠~~? 버튼 모음
  const buttons = [
    {
      label: t('after.button5'),
      onClick: handleReset,
    },
    {
      color: 'secondary',
      label: t('after.button6'),
      onClick: () => setIsReset(false),
    },
  ];

  const handleButtonClick = item => {
    console.log('item>>', item);
    const htmalias = sStorage.getItem('htmAlias') || 'jan';
    const htmSession = sStorage.getItem('sessionId');
    const { cmd, param } = item;

    //영수증은 HtmReceiptDateFlag 추가해야한다
    let url =
      'https://' +
      htmalias +
      '.himgt.net/servlets/APIMaster?Model=HtmYearEndReceipt&CMD=' +
      cmd +
      '&HtmType=' +
      activeTab +
      '&HtmSession=' +
      htmSession;
    if (param) url += param;
    setIframeSrc(url);
  };

  const handleInstallment = async () => {
    //분납개월수 가져옴
    try {
      const response = await dispatch(getInstallment()).unwrap();

      const { resultCode, htmInstallmentMm } = response;
      if (resultCode == '1') {
        setInstallment(htmInstallmentMm);
        setIsInstallment(true);
      } else {
        //분납개월 조회에 실패하였습니다.
        alertMessage(t('after.installmentError'));
      }
    } catch (error) {
      console.error('Submit installment failed:', error);
      alertMessage(t('after.installmentError'));
    }
  };

  const handleSubmitInstallment = async () => {
    try {
      const response = await dispatch(
        setInstallmentApi({
          htmInstallmentMm: installment,
          htmInstallmentFlag: installment ? '1' : '',
        }),
      ).unwrap();
      const { resultCode, msg } = response;
      if (resultCode == '1') {
        //저장되었습니다.
        alertMessage(tCommon('alertMessage.saveSuccess'));
        setIsInstallment(false);
      } else {
        //분납개월 저장에 실패하였습니다.
        alertMessage(t('after.installmentError2'));
      }
    } catch (error) {
      console.error('Submit installment failed:', error);
      alertMessage(t('after.installmentError2'));
    }
  };

  const openAddDocument = () => {
    setIframeSrc(
      'https://yearend-addon-web.himgt.net/addBoard/main?key=' +
        sStorage.getItem('sessionId') +
        '&alias=' +
        sStorage.getItem('htmAlias'),
    );
    setIsAddDocument(false);
  };

  return (
    <>
      <div className="displayFlexColumn" style={{ gap: '8px' }}>
        <div className="displayFlex" style={{ gap: '8px' }}>
          <img src={speaker} alt={`${t('title0')} `} />
          <Typography className="body1Bold">{t('title0')}</Typography>
        </div>
        {/* checkMsg , 월급날 결과 */}
        <CollapsibleBanner
          title={getResultQueryTitle(resultData, t)}
          description={getResultQueryDescription(resultData, t, msgData, isCertify)}
        />
      </div>
      {/* 초기화버튼 */}
      <div className="displayFlex" style={{ justifyContent: 'space-between' }}>
        <Typography className="body1Bold">{t('title1')}</Typography>
        {resultData?.htmViewMagam != '1' ? (
          // 초기화
          <Button
            deleteButton
            size="xSmall"
            value={t('after.button4')}
            onClick={() => setIsReset(true)}
            imgStyle={{ width: '16px', height: '16px' }}
            color="gray"
            variant="outline"
          />
        ) : (
          // 결과상세보기
          <Button
            size="xSmall"
            value={t('after.button7')}
            onClick={() => handleButtonClick({ cmd: 'YA009' })}
            imgStyle={{ width: '16px', height: '16px' }}
            color="gray"
            variant="outline"
            alt={t('after.button7')}
          />
        )}
      </div>

      {/* 모의계산, 월급날검토 */}
      <TabContentPanel tabs={TabList} activeTab={activeTab} onTabChange={handleTabChange}>
        <Tab1Content
          resultData={resultData}
          buttonList={TabList[activeTab - 1].buttonList}
          handleButtonClick={handleButtonClick}
          badge={TabList[activeTab - 1].badge}
          amount={TabList[activeTab - 1].amount}
          title={TabList[activeTab - 1].contentTitle}
          activeTab={activeTab}
          imgSrc={TabList[activeTab - 1].imgSrc}
          alt={TabList[activeTab - 1].contentTitle}
        />
      </TabContentPanel>
      {/* 추가서류접수, 분납신청 */}
      {resultData?.htmViewMagam == '1' && (
        <div className="displayFlexColumn" style={{ gap: '8px' }}>
          <ResultButton
            title="추가 서류 접수하기"
            imgSrc={resultquery_adddocument_img}
            onClick={() =>
              resultData.resultNumber == '0' ? setIsAddDocument(true) : openAddDocument()
            }
          />
          {comYASetting.htmInstallmentUseFlag == '1' &&
            resultData.htmYAResultTxt.includes('징수') && (
              <ResultButton
                title="분납 신청하기"
                imgSrc={resultquery_installment_img}
                onClick={handleInstallment}
              />
            )}
        </div>
      )}

      {/* 연말정산 결과리포트 */}
      <ResultReport {...{ resultData }} />
      {/* 영수증 iframe */}
      <IframeViewer isOpen={iframeSrc != ''} file={iframeSrc} onClose={() => setIframeSrc('')} />

      {/* 초기화~~~? dialog*/}
      <SlideDialogV
        isOpen={isReset}
        title={t('after.resetTitle')}
        description={t('after.resetDescription')}
        buttons={buttons}
        onClose={() => setIsReset(false)}
      />
      {/* 분납신청 모달 */}
      <SlideDialogV
        isOpen={isInstallment}
        title={t('after.installmentTitle') || '분납 개월수를 선택하세요'}
        innertComponent={
          <InstallmentModal installment={installment} setInstallment={setInstallment} />
        }
        buttons={[
          {
            label: t('after.button8'), //신청
            onClick: handleSubmitInstallment,
          },
        ]}
        onClose={() => setIsInstallment(false)}
      />
      {/* 추가환급 불가안내 */}
      <SlideDialogV
        isOpen={isAddDocument}
        title={t('after.addDocumentTitle') || '추가 환급이 불가합니다'}
        description={t('after.addDocumentDescription')}
        buttons={[
          {
            label: t('after.button9'), //추가서류를 제출할게요.
            onClick: () => openAddDocument(),
          },
          {
            label: t('after.button10'), //취소하겠습니다
            onClick: () => setIsAddDocument(false),
            color: 'secondary',
          },
        ]}
        onClose={() => setIsAddDocument(false)}
      />
    </>
  );
};

export default AfterAuthentication;
